// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var CaretLeft = function CaretLeft(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M10.195 2.775L5.248 7.722a.394.394 0 000 .557l4.946 4.946a.394.394 0 00.672-.278V3.054a.394.394 0 00-.671-.279z"
    }))
  );
};

export default CaretLeft;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/CaretLeft.js
// module id = 988
// module chunks = 0